import { createRegistry, runStrategy } from '@luna/utils';

import type { AliasChange, AliasChangeStrategyShape } from '../types/aliasChange';

const aliasRegistry = createRegistry<AliasChangeStrategyShape>();

export const registerAliasChangeStrategy = (
    name: string,
    strategy: AliasChangeStrategyShape,
): void => {
    aliasRegistry.set(name, strategy);
};

/**
 * Getter for the alias updating function by product type.
 */

export const getChangeAliasFunctionByProductType = (
    account?: any & { derivedType: string },
): AliasChange => {
    if (!account) {
        return () => {
            throw new Error('Account is undefined');
        };
    }
    const changeAliasStrategy = runStrategy(Object.values(aliasRegistry.getAll()), {
        arg: account,
    });

    if (!changeAliasStrategy) {
        return () => {
            throw new Error(
                `Alias change strategy for the provided account type "${account.derivedType}" does not exist.`,
            );
        };
    }
    const { changeAccountAlias } = changeAliasStrategy;

    return changeAccountAlias;
};
